import type { CoreCustomer } from '@/lib/zifekCore';

interface Props {
  customers: CoreCustomer[];
  orgNameById: Record<number, string>;
}

export default function CustomersPanel({ customers, orgNameById }: Props) {
  if (customers.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-background-50 border border-background-200/70 rounded-lg">
        <div className="w-14 h-14 rounded-full bg-background-100 flex items-center justify-center mb-3">
          <i className="ri-user-star-line text-2xl text-foreground-400"></i>
        </div>
        <p className="text-foreground-600">Aucun client.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      {customers.map((c) => (
        <div key={c.id} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
          <div className="flex items-start justify-between gap-3 mb-3">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-10 h-10 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center flex-shrink-0">
                <i className="ri-user-3-line text-lg"></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-foreground-950 truncate">
                  {c.display_name || c.company_name || `Client #${c.id}`}
                </div>
                <div className="text-[11px] text-foreground-400 truncate">
                  {c.organization_id ? (orgNameById[c.organization_id] || `Org #${c.organization_id}`) : '—'}
                </div>
              </div>
            </div>
            {c.user_id ? (
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-100 text-primary-900 font-medium whitespace-nowrap">
                Compte Zifek
              </span>
            ) : (
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 font-medium whitespace-nowrap">
                Invité
              </span>
            )}
          </div>
          <div className="text-xs text-foreground-500 space-y-1">
            <div className="flex items-center gap-1.5"><i className="ri-mail-line text-foreground-400"></i><span className="truncate">{c.email || '—'}</span></div>
            <div className="flex items-center gap-1.5"><i className="ri-phone-line text-foreground-400"></i><span className="truncate">{c.phone || '—'}</span></div>
            <div className="flex items-center gap-1.5"><i className="ri-price-tag-3-line text-foreground-400"></i><span className="truncate">{c.customer_type === 'company' ? 'Entreprise' : 'Particulier'}</span></div>
          </div>
        </div>
      ))}
    </div>
  );
}